import { render } from "./MenuItem.vue?vue&type=template&id=23fb4756&ts=true"
import script from "./MenuItem.vue?vue&type=script&lang=ts"
export * from "./MenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__